import { render, staticRenderFns } from "./rightThree.vue?vue&type=template&id=053ed63c&scoped=true&"
import script from "./rightThree.vue?vue&type=script&lang=js&"
export * from "./rightThree.vue?vue&type=script&lang=js&"
import style0 from "./rightThree.vue?vue&type=style&index=0&id=053ed63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ed63c",
  null
  
)

export default component.exports